import React from 'react'
import ImagesPallet from '../../../../utils/ImagesPallet'

function ThirthSection() {
 const values = [
    { letter: 'P', word: 'Profesional' },
    { letter: 'A', word: 'Akurat' },
    { letter: 'P', word: 'Peduli' },
    { letter: 'A', word: 'Antusias' },
    { letter: 'K', word: 'Kreatif' },
    { letter: 'I', word: 'Integritas' },
    { letter: 'L', word: 'Loyalitas' },
    { letter: 'O', word: 'Optimis' }
  ];

  return (
    <div 
      className="min-h-screen bg-center bg-cover bg-no-repeat relative justify-center items-center flex"
      style={{
        backgroundImage: "url('" + ImagesPallet.BarberRoom + "')",
      }}
    >
      <div className="absolute grid grid-rows-2  inset-0 bg-black/80" />
       {/* Konten section */}
        <div className="relative z-10 container mx-auto px-4">
        {/* Title */}
        <div className="text-center animate-fade-in hover:animate-bounce">
              <style>
                {`
                  @keyframes fadeIn {
                    from {
                      opacity: 0;
                      transform: translateY(20px);
                    }
                    to {
                      opacity: 1;
                      transform: translateY(0);
                    }
                  }
                  
                  .animate-fade-in {
                    animation: fadeIn 1.5s ease-out forwards;
                  }

                  .golden-text {
                    background: linear-gradient(
                      to bottom,
                      #A75B3B 0%,
                      #ffffff 50%,
                      #ffffff 100%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
                    letter-spacing: 0.05em;
                    font-family: "Arial Black", sans-serif;
                  }

                  .golden-text:hover {
                    background: linear-gradient(
                      to bottom,
                      #fff 0%,
                      #ffd700 50%,
                      #daa520 100%
                    );
                    -webkit-background-clip: text;
                    background-clip: text;
                    cursor: pointer;
                  }
                `}
              </style>
              <h1 className="sm:text-5xl md:text-6xl font-black mb-2 uppercase golden-text">
                budaya kerja
              </h1>
            </div> 
        
        {/* Budaya Kerja */}
        <div className="relative w-full h-72 flex justify-center items-center overflow-hidden mt-14">
            <div className="grid grid-cols-8 gap-10 hover:gap-24 duration-500 text-center bg-transparent w-min-screen p-6 hover:text-8xl text-6xl text-white ">
               {values.map(({ letter, word }, index) => (
                 <div key={index} className="group relative ">
                   <h1 className="transition-all duration-500">
                     {letter}
                   </h1>
                   <p className="text-white group-hover:opacity-100 text-2xl opacity-0 transition-all duration-500 mt-4 absolute w-full text-center left-1/2 -translate-x-1/2">
                     {word}
                   </p>
                 </div>
              ))}
              
            </div>
          </div>
         
       </div>
    </div>
  )
}

export default ThirthSection